import { formatFileSize } from 'cando-util';
import { getStorage, ref, uploadBytesResumable } from 'firebase/storage';
import { v4 as uuidv4 } from 'uuid';

export const uploadFiles = async (responses, sections, onProgress, uploadsCollection = 'submissions') => {
	const fileResponses = sections
		.flatMap(s => s.questions)
		.filter(q => q.type?.value === 'file')
		.map(q => q.label.value)
		.map(l => ({ key: l, files: responses[l] }));

	const storage = getStorage(); // Initialize Firebase Storage
	const submissionId = responses.submissionId || uuidv4();
	let totalBytes = 0;
	let uploadedBytes = 0;

	const files = [];

	for (const fileResponse of fileResponses) {
		if (typeof fileResponse.files !== 'object') continue; // no files in field?
		for (const [key, file] of Object.entries(fileResponse.files)) {
			if (!file.dataUrl) continue;
			const actualFile = dataURItoFile(file.dataUrl, file.name);
			files.push({
				file: actualFile,
				responseFieldKey: fileResponse.key,
				uploaded: file.uploaded // still need post process to update formData but just don't need to upload it
			});
			totalBytes += actualFile.size;
		}
	}

	console.log({ files, totalBytes });

	const uploads = files.map(f => new Promise((resolve, reject) => {
		const { responseFieldKey, file, uploaded } = f;
		const path = `uploads/${uploadsCollection}/${submissionId}/${responseFieldKey.replace(/\.value/g, '').split('.').join('/')}/${file.name}`;
		if (uploaded === true) {
			return resolve({
				name: file.name,
				path,
				type: file.type,
				size: file.size,
				formattedSize: formatFileSize(file.size),
				key: responseFieldKey,
				uploadedAt: new Date().toISOString(),
				uploaded: true
			});
		}
		const storageRef = ref(storage, path);
		const uploadTask = uploadBytesResumable(storageRef, file, { contentType: file.type });

		let lastTransferred = 0;

		uploadTask.on(
			"state_changed",
			(snapshot) => {
				// track delta
				const delta = snapshot.bytesTransferred - lastTransferred;
				lastTransferred = snapshot.bytesTransferred;

				uploadedBytes += delta;

				if (onProgress) {
					onProgress(uploadedBytes, totalBytes);
				}
			},
			reject,
			async () => {
				resolve({
					name: file.name,
					path,
					type: file.type,
					size: file.size,
					formattedSize: formatFileSize(file.size),
					key: responseFieldKey,
					uploadedAt: new Date().toISOString(),
					uploaded: true
				});
			}
		);

	}));

	const uploadsResponse = await Promise.all(uploads);

	const formData = { ...responses };

	for (const file of uploadsResponse) {
		const fileObj = {
			name: file.name,
			path: file.path,
			type: file.type,
			size: file.size,
			formattedSize: file.formattedSize,
			uploaded: file.uploaded,
			uploadedAt: file.uploadedAt
		};

		if (responses[file.key]?.[file.name]?.width) {
			fileObj.width = responses[file.key][file.name].width;
		}
		if (responses[file.key]?.[file.name]?.height) {
			fileObj.height = responses[file.key][file.name].height;
		}


		responses[file.key] = {
			...responses[file.key],
			[file.name]: {
				...(responses[file.key]?.[file.name] || {}),
				...fileObj
			}
		};
		formData[file.key] = {
			...formData[file.key],
			[file.name]: {
				...fileObj
			}
		};
	}
	responses.submissionId = submissionId;
	formData.submissionId = submissionId;

	return formData;
};

const dataURItoFile = (dataURI, fileName) => {
	const [meta, base64] = dataURI.split(',');
	const mime = meta.match(/:(.*?);/)[1];
	const binary = atob(base64);
	const array = new Uint8Array(binary.length);

	for (let i = 0; i < binary.length; i++) {
		array[i] = binary.charCodeAt(i);
	}

	return new File([array], fileName, { type: mime });
};
